import React, { useState } from 'react';
import { FiPlus, FiMinus } from 'react-icons/fi';
import classes from './FAQ.module.scss';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className={`${classes.faqItem} ${isOpen ? classes.open : ''}`} onClick={onClick}>
      <div className={classes.faqQuestion}>
        <h3>{question}</h3>
        <span className={classes.faqToggle}>
          {isOpen ? <FiMinus /> : <FiPlus />}
        </span>
      </div>
      <div className={classes.faqAnswer}>
        <p>{answer}</p>
      </div>
    </div>
  );
};

const FAQ = ({ faqs, title = 'Frequently Asked', highlight = 'Questions' }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className={classes.faqSection}>
      <div className={classes.container}>
        <div className={classes.sectionHeader}>
          <h2 className={classes.sectionTitle}>
            {title} <span className={classes.gradient}>{highlight}</span>
          </h2>
        </div>
        <div className={classes.faqList}>
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
